<template>
  <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-4">
    <div class="border radius-0">
      <div class="position-relative">
        <template v-if="data.merchant_image.length > 0">
          <flickity ref="flickity"
            :options="slider_option">
            <div class="carousel-cell w-100" 
              v-for="slider_merchant in data.merchant_image">
              <img :src="slider_merchant.image_url" class="w-100 object-fit rounded-top-4" height="300">
            </div>
          </flickity>
        </template>
        <img v-else :src="data.image_url" class="w-100 object-fit rounded-top-4" height="300">
        <p class="mb-0 body-3-1 position-absolute cursor-pointer ota-link-detail"
          @click="openMerchantHome()">
          Property Detail
        </p>
      </div>
      <div class="p-4 position-relative">
        <p class="mb-0 font-bold text-20 text-semi-dark text-truncate">{{ data.name }}</p>
        <div class="mt-2 mb-2 no-ws">
          <svg class="d-inline-block position-relative align-top mt-1 mr-2" width="16" height="16" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.604 4.72899C1.604 2.62072 3.36578 0.916687 5.49683 0.916687C7.63389 0.916687 9.39567 2.62072 9.39567 4.72899C9.39567 5.79138 9.0093 6.77768 8.37336 7.61366C7.67179 8.5358 6.80708 9.33924 5.83375 9.96988C5.61099 10.1156 5.40995 10.1266 5.16546 9.96988C4.18659 9.33924 3.32188 8.5358 2.62632 7.61366C1.98991 6.77768 1.604 5.79138 1.604 4.72899ZM4.21386 4.8477C4.21386 5.55397 4.79018 6.10945 5.49683 6.10945C6.20395 6.10945 6.78582 5.55397 6.78582 4.8477C6.78582 4.14693 6.20395 3.5644 5.49683 3.5644C4.79018 3.5644 4.21386 4.14693 4.21386 4.8477Z" fill="#999999"/>
          </svg>
          <p class="mb-0 text-16 d-inline-block font-regular color-grey-ga underline w-85 align-top text-truncate-2" style="height: 48px;">{{ data.address }}</p>
        </div>
        <p class="mb-3 text-16 font-regular color-grey-ga"><template v-if="data.star > 0">{{ data.star }} Star <span class="bullet-1 mx-1"></span></template> <template v-if="!(data.merchant_area_size == '' || data.merchant_area_size == '0.00')">{{ data.merchant_area_size }}m² <span class="bullet-1 mx-1"></span></template> <template v-if="data.merchant_total_rooms > 0">{{ data.merchant_total_rooms }} {{ $pluralWord(data.merchant_total_rooms,'Room') }}</template></p>
        <p class="mb-0 text-13 font-regular color-grey-ga" :class="{'top-15px pt-13px':data.lowest_room_rate.best_price.promotion_percent >= 0}">START FROM</p>
        <div class="row">
          <div class="col-12 col-lg-12 col-xl-6">
            <template v-if="data.lowest_room_rate.best_price.promotion_percent < 0">
              <p class="mb-0 text-16 font-regular color-grey-ga text-line-through d-inline-block position-relative" style="top:-5px">{{ $formatCurrency(data.lowest_room_rate.best_price.price) }}</p>
              <div class="d-inline-block position-relative">
                <p class="mb-0 d-inline-block bg-primary-opacity radius-0" style="padding: 11px 23px"></p>
                <span class="mb-0 color-primary-ota text-13 font-bold position-absolute" style="left: 7px;top: 3px;">{{ data.lowest_room_rate.best_price.promotion_percent }}%</span>
              </div>
            </template>
            <p class="mb-0 font-bold text-semi-dark text-20" :class="{'top-18px':data.lowest_room_rate.best_price.promotion_percent >= 0}">{{$formatCurrency(data.lowest_room_rate.best_price.final_price)}}</p>
          </div>
          <div class="col-12 col-lg-12 col-xl-6 align-self-center text-right">
            <button class="px-4 border-none g-btn-primary-ota g-btn-lg radius-0 py-12px" type="button" @click="openDetail()">
              Book Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Flickity from 'vue-flickity';
  export default{
    components:{
      Flickity
    },
    props: ['data'],
    data(){
      return{
        slider_option:{
          prevNextButtons: false,
          initialIndex: 0,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
        without_promo: false
      }
    },
    methods:{
      openDetail(){
        this.$emit('openDetail',this.data)
      },
      openMerchantHome(){
        this.$emit('openDetailHome',this.data)
      }
    }
  }
</script>
<style scoped>
  .ota-link-detail{
    padding: 8px 20px;
    border-radius: 40px;
    background-color: rgba(255,255,255,0.8);
    color: #222 !important;
    bottom:1rem; right:1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/community/MerchantItem.vue